/* eslint-disable */
"use strict";
import { fetchTO } from "@/components/helpers";
// const service = process.env.VUE_APP_service_scontrini || '' // usato solo per installazione su Windows 32bit (senza IIS con reverse proxy)
var config, service;
(async () => {
  const response = await fetch(process.env.BASE_URL + "config.json");
  config = await response.json();
  service = config.service_scontrini || process.env.VUE_APP_service_scontrini;
})();

async function cicleSync(multiplo) {
  try {
    const response = await fetch(`${service}/cicleSync`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ multiplo }),
    });
    return await response.json();
  } catch (error) {
    return null;
  }
}

async function getRunMode() {
  try {
    const response = await fetchTO(`${service}/mode`);
    const result = await response.json();
    if (result.status === 404) {
      return defaultRunMode();
    }
    return result;
  } catch {
    return defaultRunMode();
  }
}

function defaultRunMode() {
  return {
    modulo: "SCONTRINI",
    locale: "---",
    remote: "---",
    versione: "---",
    health: "---",
  };
}

async function getAllReceipts() {
  const response = await fetch(`${service}/`);
  return await response.json();
}

async function elencoScontriniPerData(dataDa, dataA, limit) {
  const data = {
    dataDa,
    dataA,
    limit,
  };
  const response = await fetch(`${service}/data`, {
    headers: { "Content-Type": "application/json" },
    method: "POST",
    body: JSON.stringify(data),
  });
  return await response.json();
}

async function nuovoScontrino(postazione, codiceAzienda, idNuovoScontrino) {
  console.log("[nuovoScontrino] creazione scontrino");
  var data = {
    postazione: postazione,
  };
  if (codiceAzienda) {
    data.azienda = codiceAzienda;
    data.numero = idNuovoScontrino;
  }
  const response = await fetch(`${service}/create`, {
    headers: { "Content-Type": "application/json" },
    method: "POST",
    body: JSON.stringify(data),
  });
  return await response.json();
  /*   const response = await fetch(`${service}/create`, { method: 'POST' })
  const json = await response.json()
  console.log('[nuovoScontrino] json:', json)
  return json */
}

async function nuovoScontrinoConRighe(
  righe,
  postazione,
  codiceAzienda,
  idNuovoScontrino
) {
  var data = {
    righe,
    postazione: postazione,
  };
  if (codiceAzienda) {
    data.azienda = codiceAzienda;
    data.numero = idNuovoScontrino;
  }
  const response = await fetch(`${service}/create`, {
    headers: { "Content-Type": "application/json" },
    method: "POST",
    body: JSON.stringify(data),
  });
  return await response.json();
}

async function addRigaScontrino(idScontrino, riga) {
  const response = await fetch(`${service}/${idScontrino}/add`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(riga),
  });
  return await response.json();
}

async function addRigheScontrino(idScontrino, righe) {
  const response = await fetch(`${service}/${idScontrino}/add/rows`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(righe),
  });
  return await response.json();
}

async function updateRigaScontrino(idScontrino, idRiga, riga) {
  const response = await fetch(`${service}/${idScontrino}/update/${idRiga}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(riga),
  });
  return await response.json();
}

async function updateRigheScontrino(idScontrino, righe) {
  const response = await fetch(`${service}/${idScontrino}/update/rows`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(righe),
  });
  return await response.json();
}

async function deleteRigaScontrino(idScontrino, idRiga) {
  console.log("deleteRigaScontrino", idRiga);
  const response = await fetch(`${service}/${idScontrino}/delete/${idRiga}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  });
  return await response.json();
}

async function deleteRigaScontrinoByCode(idScontrino, codiceRiga) {
  console.log("deleteRigaScontrinoByCode", codiceRiga);
  const response = await fetch(
    `${service}/${idScontrino}/delete/code/${codiceRiga}`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    }
  );
  return await response.json();
}

async function addTotaleScontrino(
  idScontrino,
  righeScontrino,
  infoChiusuraScontrino
) {
  // in base al contenuto di infoChiusuraScontrino richiamo più volte la add riga ...

  await updateRigheScontrino(idScontrino, righeScontrino);
  /*   debugger
  let rigaDaAggiungere = infoChiusuraScontrino.resto ? 4 : 2
  while (rigaDaAggiungere) {
    await addRigaScontrino(idScontrino, righeScontrino[righeScontrino.length - rigaDaAggiungere])
    rigaDaAggiungere--
  } */
}

async function cancellaScontrino(idScontrino) {
  const response = await fetch(`${service}/${idScontrino}/delete`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  });
  return await response.json();
}

async function aggiornaFiscaleScontrino(idScontrino, info, infoChiusura) {
  // Aggiungere anche eventuali arrotondamenti ?
  const data = {
    fiscale: info,
    pagamento: {
      pagamenti: infoChiusura.pagamenti,
      totale: infoChiusura.totale,
      resto: infoChiusura.resto,
    },
    stato: infoChiusura.stato,
    // statoPagamento: ....  // TODO gestire per credito o fattura ...
  };
  if (infoChiusura.fidelity) {
    data.fidelity = infoChiusura.fidelity;
  }
  if (infoChiusura.documento) {
    data.documento = infoChiusura.documento;
  }
  if (infoChiusura.cashmatic) {
    data.cashmatic = infoChiusura.cashmatic;
  }
  if (infoChiusura.operatore) {
    data.operatore = infoChiusura.operatore;
  }
  if (infoChiusura.cliente) {
    data.cliente = infoChiusura.cliente;
  }
  const response = await fetch(`${service}/${idScontrino}/fiscale`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return await response.json();
}

async function aggiornaDocumentoScontrino(idScontrino, documento, nonFiscali) {
  const data = {
    documento,
    nonFiscali,
  };

  const response = await fetch(`${service}/${idScontrino}/documento`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return await response.json();
}

async function getScontrino(barcode) {
  const response = await fetch(`${service}/barcode/${barcode}`);
  return await response.json();
}

async function getScontrinoById(id) {
  const response = await fetch(`${service}/${id}`);
  return await response.json();
}

async function getScontrinoByParkBarcode(barcode) {
  const response = await fetch(`${service}/park/${barcode}`);
  return await response.json();
}

async function leggeScontrinoBilanciaById(id) {
  const response = await fetch(`${service}/bilancia/${id}`)
  return await response.json()
}

async function leggeScontrinoBilanciaBarcode(barcode) {
  const response = await fetch(`${service}/barcode/bilancia/${barcode}`)
  return await response.json()
}

async function usaScontrinoBilanciaById(scontrinoBilanciaId, scontrinoPagamento) {
  const data = {
    scontrinoBilanciaId,
    scontrinoPagamento
  }
  const response = await fetch(`${service}/bilancia`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  })
  return await response.json()
}

async function resiSuScontrino(printerResi) {
  const idScontrino = printerResi.righe[0].payload.fiscale.idScontrino; // ID scontrino Origine
  var righe = printerResi.righe;
  righe.forEach((riga) => {
    delete riga.payload;
  });
  const reso = {
    fiscale: printerResi.fiscale,
    righe,
  };
  const response = await fetch(`${service}/${idScontrino}/reso`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(reso),
  });
  return await response.json();
}

async function aggiornaAnnullamentoFiscaleSuOrigine(idScontrino, info) {
  console.log("aggiornaAnnullamentoFiscaleSuOrigine", idScontrino, info);
  const response = await fetch(`${service}/${idScontrino}/annullamento`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(info),
  });
  return await response.json();
}

// verificare prima di utilizzare... non testato
async function duplicaContenutoScontrino(idScontrino) {
  const response = await fetch(`${service}/${idScontrino}/duplica`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  });
  return await response.json();
}

async function creaScontrino(dati, parcheggio, postazione) {
  var data = { ...dati, postazione };
  if (parcheggio) {
    data.parcheggio = {
      stato: "occupato",
      zona: parcheggio.zona,
      posizione: parcheggio.posizione,
      data: new Date().toJSON(),
      payload: parcheggio.payload,
      descZona: parcheggio.descZona || "",
      descContenutoZona: parcheggio.descContenutoZona || "",
    };
  }
  const response = await fetch(`${service}/create`, {
    headers: { "Content-Type": "application/json" },
    method: "POST",
    body: JSON.stringify(data),
  });
  return await response.json();
}

async function getParcheggiati() {
  const response = await fetch(`${service}/parking`);
  return await response.json();
}

async function updateScontrino(idScontrino, dati) {
  const response = await fetch(`${service}/${idScontrino}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(dati),
  });
  return await response.json();
}

async function updateScontrinoChangeDate(idScontrino, dati, istante) {
  const data = {
    dati,
    istante,
  };
  const response = await fetch(`${service}/${idScontrino}/change`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return await response.json();
}

async function annullaParcheggio(idScontrino) {
  const response = await fetch(`${service}/${idScontrino}/parking/delete`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  });
  return await response.json();
}

export default {
  cicleSync,
  getRunMode,
  getAllReceipts,
  elencoScontriniPerData,
  addRigaScontrino,
  addRigheScontrino,
  updateScontrino,
  updateScontrinoChangeDate,
  updateRigaScontrino,
  updateRigheScontrino,
  deleteRigaScontrino,
  deleteRigaScontrinoByCode,
  addTotaleScontrino,
  nuovoScontrino,
  cancellaScontrino,
  aggiornaFiscaleScontrino,
  aggiornaDocumentoScontrino,
  getScontrino,
  getScontrinoById,
  getScontrinoByParkBarcode,
  leggeScontrinoBilanciaById,
  leggeScontrinoBilanciaBarcode,
  usaScontrinoBilanciaById,
  resiSuScontrino,
  aggiornaAnnullamentoFiscaleSuOrigine,
  duplicaContenutoScontrino,
  nuovoScontrinoConRighe,
  getParcheggiati,
  creaScontrino,
  annullaParcheggio,
};
